import { Box } from '@mui/material';
import { getCompanyLogoUrl } from '@/Utils/environment';

/**
 * Left-aligned company logo rendered at the top of the page content gutter,
 * directly above the form. The block is transparent so the gray page canvas
 * (`magicLinkPageOuterSx`) shows through, keeping the logo flush with the
 * Section cards underneath instead of sitting inside a separate white strip.
 */
const Header = () => {
    const logoUrl = getCompanyLogoUrl();

    if (!logoUrl) return null;

    return (
        <Box
            component="header"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%',
                flexShrink: 0,
                // Extra bottom spacer so the logo always has breathing room
                // between itself and the content that renders below it,
                // regardless of the parent container's gap.
                marginBottom: (theme) => theme.spacing(2),
            }}
        >
            <Box
                component="img"
                src={logoUrl}
                alt="Company Logo"
                sx={{
                    height: { xs: '45px', md: '36px' },
                    width: 'auto',
                    display: 'block',
                }}
            />
        </Box>
    );
};

export default Header;
